<template>
  <div>
    <Button
      class="p-button p-button-large p-button-secondary p-my-3"
      :label="$t('Button.uploadCSV', { plural: itemInfo.plural })"
      icon="pi pi-cloud-upload"
      @click="formatDialog = true"
    />
    <Dialog
      :close-on-escape="false"
      :closable="false"
      :header="
        file
          ? $t('Dialog.headerWithItemCount', { count: this.jsonLinks.length, plural: itemInfo.plural })
          : $t('Dialog.headerWithoutItemCount', { plural: itemInfo.plural })
      "
      :visible.sync="formatDialog"
      :style="{ minWidth: '50vw' }"
      :modal="true"
    >
      <div v-if="!file">
        <table>
          <tr>
            <th v-for="h in itemInfo.headers" :key="h">{{ h }}</th>
          </tr>
          <tr>
            <td v-for="h in itemInfo.row" :key="h">{{ h }}</td>
          </tr>
        </table>

        <br />
        <div v-if="item === 'person'">
          {{ $t("Table.optionalTeam") }}
        </div>

        <div class="p-my-5">
          <input
            id="fileSelect"
            type="file"
            style="hidden"
            @change="startCsv"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
        </div>
        <div>
          <Button class="p-button-text p-my-3" :label="$t('Button.cancel')" @click="formatDialog = false" />
        </div>
      </div>

      <div v-else-if="file">
        <!-- <p>Confirm File:</p>
        <div class="p-my-3">{{ originalFile.name }}</div>
        <div>{{ $t('Button.confirmCreation', { count: jsonLinks.length, plural: itemInfo.plural }) }}</div> -->
        <table style="margin: 10px auto">
          <tr>
            <th v-for="h in itemInfo.headers" :key="h" v-html="h"></th>
          </tr>
          <tr v-for="link in jsonLinks" :key="link[0] + link[1]">
            <td v-for="(h, i) in itemInfo.headers" :key="h" style="padding-right: 10px">
              {{ link[i] }}
            </td>
            <!-- <td style="padding-right: 10px">{{ link[1] }}</td> -->
            <!-- <td>{{ link[2] }}</td> -->
            <!-- <td>{{ link[3] }}</td> -->
          </tr>
        </table>

        <Button class="p-button p-my-3 p-mr-4" @click="doCSV" :label="$t('Button.create')" />
        <Button class="p-button-text p-my-3" :label="$t('Button.cancel')" @click="file = null" />
      </div>
    </Dialog>
  </div>
</template>

<script>
export default {
  // ddd
  props: ["item"],
  data() {
    return {
      formatDialog: false,
      file: null,
      jsonLinks: [],
      originalFile: null,
      busy: false,
    };
  },
  computed: {
    itemInfo() {
      if (this.item == "team") {
        return {
          plural: "Teams",
          headers: ["Division Name", "Team Name", "Abbreviation", "Custom Code", "SE ID", "SE Mapping Code"],
          row: ["Seniors Softball", "Hawks", "HK", "S1Hawks", "232443", "345343"],
        };
      } else if (this.item == "venue") {
        return {
          plural: "Venues",
          headers: [
            "Venue Name",
            "Abbreviation",
            "Custom Code",
            "Address1",
            "Address2",
            "City",
            "State",
            "Country",
            "Zip",
            "Phone",
            "Email",
            "Latitude",
            "Longitude",
            "Map URL",
          ],
          row: [
            "Flutie Fields",
            "FL",
            "FLUTIE",
            "2101 Oak Street",
            "",
            "Melbourne Beach",
            "FL",
            "USA",
            "32951",
            "(321) 255-4400",
            "flutie@brevard.com",
            "28.0554446",
            "-80.5542206",
            "https://goo.gl/maps/HWPLc7BNn5ZKpq5W6",
          ],
        };
      } else if (this.item == "division") {
        return {
          plural: "Divisions",
          headers: ["Division Name", "Abbreviation", "Custom Code", "Notes", "SE ID", "SE Mapping Code"],
          row: ["Seniors Softball", "SSBALL", "SeniorSoft", "Some notes..", "232443", "345343"],
        };
      } else if (this.item == "person") {
        return {
          plural: "People",
          headers: [
            "First Name",
            "Last Name",
            "Division",
            "Team",
            "Role",
            "Address Line 1",
            "Address Line 2",
            "City",
            "State",
            "Zip",
            "Email",
            "Phone",
          ],
          row: [
            "Brandon",
            "Smith",
            "Seniors Softball",
            "Hawks",
            "Player",
            "303 Miami Avenue",
            "",
            "Indialantic",
            "FL",
            "32903",
            "brandon.smith@test.com",
            "321-555-1160",
          ],
        };
      } else if (this.item == "timeslot") {
        return {
          plural: "Timeslots",
          headers: ["Date (MM/DD/YYYY)", "Start", "Finish", "Venue", "Surface", "Duration", "Divisions"],
          row: ["1/20/2021", "7:00 PM", "9:00 PM", "Flutie Athletic Complex", "Majors Field", ""],
        };
      }
    },
    formatImage() {
      if (this.item == "team") {
      } else if (this.item == "venue") {
      } else if (this.item == "division") {
      } else if (this.item == "coach") {
      } else if (this.item == "player") {
      }
    },
  },
  methods: {
    doBulk(links) {
      console.log("DoBulk", links);
      api
        .createBulkPeople(this.$store.getters.currentSeason.id, links)
        .then(response => {
          this.makeToast("success", "Created People from CSV ⭐️");
          this.$store.dispatch("getLeagueInformation");
          this.goRouter("/");
          console.log(response);
        })
        .catch(error => {
          alert(this.errors);
        });
    },
    viewFormat() {
      this.formatDialog = true;
    },
    doCSV() {
      console.log("doCSV");
      this.$emit("save", this.jsonLinks);
      this.formatDialog = false;
      this.file = null;
    },
    startCsv(e) {
      this.jsonLinks = [];
      var f = e.target.files[0];
      this.originalFile = f;
      // var x = "yo";
      // console.log(f);
      var p = this.$papa.parse(f, {
        delimiter: ",",
        complete: results => {
          this.file = results.data;
          this.file.forEach((row, i) => {
            console.log(row);
            if (i != 0 && row[0]) {
              var x = 0;
              var arr = [];
              while (x < this.itemInfo.headers.length) {
                arr.push(row[x]);
                x++;
              }
              console.log(arr);
              this.jsonLinks.push(arr);
            }
          });
        },
      });
      setTimeout(() => {
        console.log(this.file);
      }, 2000);
    },
  },
};
</script>

<style scoped lang="scss">
#error-messages {
  display: flex;
  justify-content: center;
}

th {
  padding: 10px;
}
td {
  padding: 10px;
  font-size: 0.8em;
}
</style>
